
import { useState } from "react";
import { Reagent } from "@/types/reagent.types";

interface UseReagentFiltersProps {
  reagents: Reagent[];
}

export const useReagentFilters = ({ reagents }: UseReagentFiltersProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all-categories");
  const [selectedLocation, setSelectedLocation] = useState("all-locations");
  const [showFilters, setShowFilters] = useState(false);

  // Extract unique locations from reagents
  const locations = Array.from(new Set(reagents
    .map((reagent) => reagent.profiles?.location)
    .filter(Boolean) as string[]));

  // Filter reagents based on current filter state
  const filteredReagents = reagents.filter((reagent) => {
    const matchesSearch = searchTerm === "" || 
      reagent.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (reagent.catalogue_number && reagent.catalogue_number.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (reagent.description && reagent.description.toLowerCase().includes(searchTerm.toLowerCase()));
    
    const matchesCategory = 
      selectedCategory === "all-categories" || 
      reagent.categories?.id === selectedCategory;
    
    const matchesLocation = 
      selectedLocation === "all-locations" || 
      reagent.profiles?.location === selectedLocation;
    
    return matchesSearch && matchesCategory && matchesLocation;
  });

  // Reset all filters to default state
  const resetFilters = () => {
    setSearchTerm("");
    setSelectedCategory("all-categories");
    setSelectedLocation("all-locations");
  };

  return {
    // Filter state
    searchTerm,
    setSearchTerm,
    selectedCategory,
    setSelectedCategory,
    selectedLocation,
    setSelectedLocation,
    showFilters,
    setShowFilters,
    
    // Filtered data
    filteredReagents,
    locations,
    
    // Actions
    resetFilters
  };
};
